import { useAppDispatch, useAppSelector } from 'hooks/useStore'
import { ReactElement } from 'react'
import styled from 'styled-components'
import FactureList from 'components/FactureList/FactureList'
import { factureListActions } from 'modules/facturation/store/store.facturation'

export default function ArtisanFacturation(): ReactElement {
  const dispatch = useAppDispatch()
  const { artisan, isLoading, factureList } = useAppSelector((state) => state.artisan)

  return !isLoading && artisan ? (
    <Wrapper>
      <FactureList
        factureList={factureList}
        updatePayment={(id: string) => dispatch(factureListActions.updateFacturePayment(id))}
      />
    </Wrapper>
  ) : null
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`
